import { amountsMatch } from '../money.js';
const AMOUNT_FIELDS = ['subtotal', 'taxAmount', 'totalAmount'];
/**
 * The currency the invoice is actually billed in: the document's, when
 * extraction read one, else the company's. Once a reviewer confirms a misread
 * currency the document field holds the company's, so the two agree again.
 */
export function invoiceBilledCurrency(invoice) {
    const read = invoice.extraction?.fields?.currency?.value;
    const document = typeof read === 'string' ? read.trim().toUpperCase() : '';
    return document || invoice.currency || 'INR';
}
/**
 * Compares a PO with an invoice, field by field.
 *
 * Used by the review screen for its chips and by the server to decide what to
 * keep when a PO is linked, so the two can never disagree. Amounts match
 * within the platform's tolerance (₹1 or 0.5%); amounts in two currencies say
 * nothing about each other and are not compared.
 */
export function comparePurchaseOrder(po, invoice) {
    const invoiceCurrency = invoiceBilledCurrency(invoice);
    const sameCurrency = po.currency === invoiceCurrency;
    const checks = [
        {
            field: 'currency',
            ok: sameCurrency,
            poValue: po.currency,
            invoiceValue: invoiceCurrency,
        },
    ];
    for (const field of AMOUNT_FIELDS) {
        const poValue = po[field];
        const invoiceValue = invoice[field] ?? null;
        checks.push({
            field,
            ok: !sameCurrency || poValue === null || invoiceValue === null
                ? null
                : amountsMatch(poValue, invoiceValue),
            poValue,
            invoiceValue,
        });
    }
    const poGstin = po.vendorGstin?.trim().toUpperCase() || null;
    const invoiceGstin = invoice.gstin?.trim().toUpperCase() || null;
    checks.push({
        field: 'vendorGstin',
        ok: poGstin === null || invoiceGstin === null ? null : poGstin === invoiceGstin,
        poValue: poGstin,
        invoiceValue: invoiceGstin,
    });
    return checks;
}
/** Only the fields that disagree: what is kept on the invoice when it is linked. */
export function purchaseOrderMismatches(po, invoice) {
    return comparePurchaseOrder(po, invoice)
        .filter((check) => check.ok === false)
        .map((check) => ({
        field: check.field,
        poValue: check.poValue,
        invoiceValue: check.invoiceValue,
    }));
}
//# sourceMappingURL=purchaseOrder.js.map